module.exports = {
  KOMPAKT: { api: 'KOMPAKT', human: 'Kompakt', fullName: 'KFZ Haftpflicht und Teilkasko' },
  KOMFORT: { api: 'KOMFORT', human: 'Komfort', fullName: 'KFZ Haftpflicht und Vollkasko' },
  EXCLUSIV: { api: 'EXCLUSIV', human: 'Exklusiv', fullName: 'KFZ Haftpflicht und MultiRisk' }
}
